<template>
  <div>
    <el-table
      :data="data"
      style="width: 100%"
      size="medium"
      header-row-class-name="supervision-table-header"
      row-class-name="common-table-row"
      class="is-print-hide common-table"
      border
    >
      <el-table-column label="药品通用名" prop="drugName"></el-table-column>
      <el-table-column v-if="type === 'special'" label="规格" prop="drugSpec"></el-table-column>
      <el-table-column label="数量" prop="drugNum">
        <template #default="{ row: { drugNum, drugUnit } }">
          <span>{{ `${drugNum}${drugUnit || ''}` }}</span>
        </template>
      </el-table-column>
      <el-table-column label="销售时间" :min-width="100">
        <template #default="{ row: { orderTime } }">
          {{ orderTime | formatTime }}
        </template>
      </el-table-column>
      <el-table-column prop="storeContactsName" label="登记状态" :min-width="100">
        <template #default="{ row: { registrationStatus, correctionStatus } }">
          <span
            :class="{
              red: registrationStatus === 9,
              green: registrationStatus === 1,
              yellow: registrationStatus === 0
            }"
          >
            {{ registrationStatus | adaptStatus }}
          </span>
          <el-tag type="success" v-if="correctionStatus == 1" size="mini">已校正</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="销售订单号" prop="orderId" :min-width="180">
        <template #default="{ row: { patchedStatus, orderId } }">
          {{ orderId }}
          <el-tooltip class="item" effect="dark" content="订单非销售当日上传" placement="top-start">
            <el-tag type="danger" v-if="patchedStatus == 1" size="mini">补传</el-tag>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template
          #default="{
            row: {
              orderId,
              orderDetailId,
              drugName,
              storeName,
              orderTime,
              correctionStatus,
              correctionTime,
              correctionFileUrlList,
              correctionRemark,
              correctionTypeDesc
            }
          }"
        >
          <el-button
            type="text"
            v-if="correctionStatus == 1"
            @click="
              () =>
                handleClickRow({
                  orderId,
                  drugName,
                  storeName,
                  orderTime,
                  correctionTime,
                  correctionFileUrlList,
                  correctionRemark,
                  correctionTypeDesc
                })
            "
          >
            查看校正
          </el-button>
          <el-button
            type="text"
            v-else-if="correctionStatus == 0"
            @click="() => handleEditRow({ orderId, drugName, storeName, orderTime, orderDetailId })"
          >
            点击校正
          </el-button>
          <div v-else>--</div>
        </template>
      </el-table-column>
    </el-table>
    <Drawer ref="drawer" :correctionTypeCodeMap="correctionTypeCodeMap" />
    <DrawerEdit
      :type="type === 'special' ? 'Narcotic' : 'Epidemic'"
      ref="drawerEdit"
      :correctionTypeCodeMap="correctionTypeCodeMap"
      @reload="$emit('update')"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import Drawer from './drawerDetail.vue';
import DrawerEdit from './drawer.vue';

export default {
  components: { Drawer, DrawerEdit },
  name: 'supervisionList',
  props: {
    type: {
      type: String
    },
    data: {
      type: Array,
      default: () => []
    },
    correctionTypeCodeMap: {
      type: Object,
      default: () => ({})
    }
  },
  filters: {
    formatTime(val) {
      return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
    },
    adaptStatus(val) {
      const statusMap = { 9: '未登记', 1: '已登记', 0: '待登记' };
      return statusMap[val];
    },
    adaptPatchStatus(val) {
      const statusMap = { 1: '补传', 0: '当日上传' };
      return statusMap[val];
    }
  },
  methods: {
    handleClickRow(row) {
      // console.log(this.$refs.drawer);
      this.$refs.drawer.init(row);
    },
    handleEditRow(row) {
      this.$refs.drawerEdit.init(row);
    }
  }
};
</script>

<style lang="scss" scoped>
.drug-item {
  position: relative;
  padding: 5px 0;

  .drug-title {
    font-weight: 500;
  }

  &:before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: #efefef;
  }

  &:last-child {
    &:before {
      display: none;
    }
  }
}

.red {
  color: #eb3c36;
}

.green {
  color: #1e8dff;
}

.yellow {
  color: #ebb436;
}
</style>
